import react, { Component } from "react";
import {
  DKLabel,
  DKButton,
  showToast,
  TOAST_TYPE,
  DKSpinner,
  DKCalendar,
  DKIcon,
  DKIcons,
  DKLine,
  DKInput,
  INPUT_VIEW_DIRECTION,
  Toggle,
} from "deskera-ui-library";
import date_range from "../../assets/icons/white/date_range.svg";
import moment from "moment";
import { saveAs } from "file-saver";
import PayrollLiabilityGrid from "../reports/compliance/IN/PayrollLiabilityGrid";
import RouteManager from "../../managers/RouteManager";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ReportService from "../../services/ReportService";
import { INPUT_TYPE } from "../../constants/Constant";
import SyncJEToBooksTable from "./SyncJEToBooksTable";
import BooksIntegrationService from "../../services/BooksIntegrationService";
import Utility from "../../utility/Utility";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
export default class SyncJEPopUp extends Component {
  data = [];
  constructor(props) {
    super(props);
    this.state = {
      timePeriod: {
        toggle: false,
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month"),
        defaultDate: false,
        hasError: false,
        errorMsg: "End date should not be less than Start date",
      },
      showReport: false,
      selectedRow: [],
    };
  }
  generate = false;
  componentDidMount() {
    RouteManager.setPresenter(this);
  }
  getTimePeriod() {
    const dateFormat = TenantService.get(TENANT.DATE_FORMAT);
    const timePeriod = this.state.timePeriod;
    return timePeriod.startDate && timePeriod.endDate
      ? `${moment(timePeriod.startDate).format(dateFormat)} - ${moment(
          timePeriod.endDate
        ).format(dateFormat)}`
      : "";
  }

  onSyncClick() {
    this.syncJEToBooks();
  }
  processBeforeSubmit() {
    let data = { payrun: [] };
    if (this.data.length != 0) {
      this.data.forEach((element) => {
        if (element.jePostedOn) {
          let obj = {
            jeDate: moment(element.jePostedOn).format("MM/DD/YYYY"),
            payrunId: element.data._id,
          };
          data.payrun.push(obj);
        }
      });
      if (data.length != 0) {
        return data;
      } else {
        return;
      }
    } else {
      showToast("Please select JE(s) to sync", TOAST_TYPE.WARNING);
      return;
    }
  }
  syncJEToBooks(payload) {
    console.log(this.data);
    let param = this.processBeforeSubmit();
    if (param) {
      BooksIntegrationService.sync(param).then(
        (response) => {
          console.log(response);
          showToast(
            "JE(s) posted successfully for given payrun(s)",
            TOAST_TYPE.SUCCESS
          );
          this.props.onClose();
        },
        (error) => {
          if (typeof error == "string") {
            if (
              error.trim() ==
              "for given payrun's, JE Posting Partially Successful"
            ) {
              showToast(
                "for given payrun's, JE Posting Partially Successful",
                TOAST_TYPE.WARNING
              );
            } else {
              showToast("Internal server error", TOAST_TYPE.FAILURE);
            }
          } else {
            showToast("Internal server error", TOAST_TYPE.FAILURE);
          }
        }
      );
    }
  }
  render() {
    return (
      <div className="popup-window" style={{ maxWidth: "70%", height: "70%" }}>
        <div className="row">
          <DKLabel
            text=" Sync to Deskera Books "
            className="fs-m fw-m align-self-center width-80"
          />
          <div className="row-reverse ">
            <DKButton
              title="Sync"
              className="border-m ml-r bg-app text-white"
              onClick={() => this.onSyncClick()}
            />
            <DKButton
              title="Cancel"
              className="g-gray1 border-m"
              onClick={(event) => {
                this.props.onClose();
              }}
            />
          </div>
        </div>
        <div className="p-v-m p-h-m">
          <span>
            {" "}
            This payrun data will be posted as Journal Entries in Deskera Books.{" "}
          </span>
        </div>
        <div className="bg-white pb-l mt-l web-width-40">
          <div className="row row-responsive">
            <div className="p-h-l parent-width " style={{ minWidth: "200px" }}>
              <div>
                <div className="row row-responsive">
                  <DKInput
                    title={"Start date"}
                    type={INPUT_TYPE.DATE}
                    value={new Date(this.state.timePeriod.startDate)}
                    required={true}
                    readOnly={false}
                    canValidate={true}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    onChange={(value) => {
                      let startDate = value;
                      let endDate = this.state.timePeriod.endDate;
                      if (
                        !Utility.isEmpty(startDate) &&
                        !Utility.isEmpty(endDate) &&
                        moment(startDate).diff(endDate) <= 0
                      ) {
                        this.setState({
                          timePeriod: {
                            toggle: false,
                            startDate: value,
                            endDate: this.state.timePeriod.endDate,
                            defaultDate: false,
                            hasError: false,
                          },
                        });
                      } else {
                        this.setState({
                          timePeriod: {
                            toggle: false,
                            startDate: value,
                            endDate: this.state.timePeriod.endDate,
                            defaultDate: false,
                            hasError: true,
                            errorMsg:
                              "End date should not be less than Start date",
                          },
                        });
                      }
                    }}
                  />
                  <DKInput
                    title={"End date"}
                    type={INPUT_TYPE.DATE}
                    value={new Date(this.state.timePeriod.endDate)}
                    required={true}
                    className={!isMobileWebView() ? `ml-l` : ""}
                    readOnly={false}
                    canValidate={true}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    onChange={(value) => {
                      let startDate = this.state.timePeriod.startDate;
                      let endDate = value;
                      if (
                        !Utility.isEmpty(startDate) &&
                        !Utility.isEmpty(endDate) &&
                        moment(startDate).diff(endDate) <= 0
                      ) {
                        this.setState({
                          timePeriod: {
                            toggle: false,
                            startDate: this.state.timePeriod.startDate,
                            endDate: value,
                            defaultDate: false,
                            hasError: false,
                          },
                        });
                      } else {
                        this.setState({
                          timePeriod: {
                            toggle: false,
                            startDate: this.state.timePeriod.startDate,
                            endDate: value,
                            defaultDate: false,
                            hasError: true,
                            errorMsg:
                              "End date should not be less than Start date",
                          },
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="mb-xs ml-l" style={{ marginTop: "30px" }}>
              <DKButton
                title="Fetch"
                // icon={DKIcons.white.ic_export}
                className="bg-app text-white"
                onClick={() => {
                  if (!this.state.timePeriod.hasError) {
                    this.generate = !this.generate;
                    this.setState({
                      ...this.state,
                      showReport: true,
                    });
                  }
                }}
              />
            </div>
          </div>
          {this.state.timePeriod.hasError && (
            <DKLabel
              className="mt-xs text-red ml-l"
              text={this.state.timePeriod.errorMsg}
            />
          )}
        </div>
        {this.state.showReport && (
          <SyncJEToBooksTable
            {...this.props}
            filter={{
              searchField: "non-synced-by-pay-period",
              searchString: `${moment(this.state.timePeriod.startDate).format(
                "MM/DD/YYYY"
              )}-${moment(this.state.timePeriod.endDate).format("MM/DD/YYYY")}`,
            }}
            isSync={true}
            generate={this.generate}
            selectedData={(row) => (this.data = row)}
          />
        )}
      </div>
    );
  }
}
